import styled from 'styled-components/macro';

const BranchContainerDivider = styled.div`
  display: block;

  border-bottom: 1px solid ${props => props.borderBottom};

  padding: 15px 0;

  width: 100%;
`;

export default BranchContainerDivider;
